import React from 'react';
import { Link } from 'react-router-dom';
import egbLogo from '../images/egbsystems-logo.png';

const NAV = [
  { label: 'Home', to: '/' },
  {
    label: 'Company Info', to: '/company/overview',
    children: [
      { label: 'Overview', to: '/company/overview' },
      { label: 'Our Expertise', to: '/company/expertise' },
      { label: 'Vision & Mission', to: '/company/vision-mission' },
      { label: 'Management Team', to: '/company/management-team' },
      { label: 'Why EGB', to: '/company/why-egb' },
      { label: 'Awards', to: '/company/awards' },
    ],
  },
  {
    label: 'Our Strategy', to: '/strategy',
    children: [
      { label: 'Business Model', to: '/strategy' },
      { label: 'Process Methodology', to: '/strategy' },
      { label: 'Quality Assurance', to: '/strategy' },
      { label: 'Development Infrastructure', to: '/strategy' },
    ],
  },
  { label: 'Services', to: '/services' },
  { label: 'AI Services ✨', to: '/ai-services', isNew: true },
  { label: 'Government', to: '/government' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'Contact Us', to: '/contact' },
];

const Header = () => (
  <>
    {/* Top bar - hidden on mobile */}
    <div className="bg-primary text-white py-1 d-none d-md-block">
      <div className="container d-flex justify-content-between" style={{ fontSize: 12 }}>
        <span>📞 USA: 203 653 2741 &nbsp;|&nbsp; 🇮🇳 India: +91 044-35510504</span>
        <span>✉️ support@egbsystems.com</span>
      </div>
    </div>

    {/* Mobile top bar */}
    <div className="bg-primary text-white text-center py-1 d-block d-md-none" style={{ fontSize: 11 }}>
      <span>📞 203 653 2741 &nbsp;|&nbsp; ✉️ support@egbsystems.com</span>
    </div>

    {/* Navbar */}
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={egbLogo} alt="EGB Systems and Solutions, Inc." style={{ height: 45, objectFit: 'contain' }} />
        </Link>

        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#egbNavbar"
          aria-controls="egbNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="egbNavbar">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
            {NAV.map((item) =>
              item.children ? (
                <li key={item.label} className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to={item.to}
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {item.label}
                  </Link>
                  <ul className="dropdown-menu" style={{ borderTop: '3px solid #1a56db' }}>
                    {item.children.map(child => (
                      <li key={child.label}>
                        <Link className="dropdown-item" to={child.to}>{child.label}</Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={item.label} className="nav-item">
                  <Link
                    className={`nav-link ${item.isNew ? 'fw-bold text-primary' : ''}`}
                    to={item.to}
                  >
                    {item.label}
                  </Link>
                </li>
              )
            )}
          </ul>
          <Link to="/contact" className="btn btn-primary ms-lg-3 mt-2 mt-lg-0">Get a Quote</Link>
        </div>
      </div>
    </nav>
  </>
);

export default Header;
